import { useFormikContext } from 'formik';
import { pluck } from '../../helpers/pluck';
import AsyncSelect from "react-select/async";
import { GroupBase, StylesConfig } from 'react-select';
import React from 'react';

interface FormValues {
  [key: string]: unknown;
}

type ComboBoxFormikProps = {
  name: string;
  label?: string;
  loadOptions: (inputValue: string) => Promise<Partial<{ label: string }>[]>;
  className?: string;
  required?: boolean;
  valueProperty?: string;
  isMulti?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  initialValue?: any[] | any; // Permitir tanto arrays quanto objetos únicos
  value?: string;
};

// eslint-disable-next-line  @typescript-eslint/ban-types
const inputStyles: StylesConfig<{}, boolean, GroupBase<{ label: string; value: string; }>> = {
  control: (styles) => ({ ...styles, borderColor: '#616161', height: "42px" })
}


const AutocompleteAsyncFormik: React.FC<ComboBoxFormikProps> = ({
  name,
  label,
  className,
  required,
  loadOptions,
  isMulti,
  valueProperty,
  initialValue
}) => {
  const { errors, values, setFieldValue } = useFormikContext<FormValues>();
  const [initialOptions, setInitialOptions] = React.useState(initialValue);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleOnChange = (options: any) => {
    const newValue = isMulti ? options : options ? [options] : [];
    setFieldValue(name, newValue);
    setInitialOptions(newValue);
  };

  React.useEffect(() => {
    if (initialValue && !values[name]) {
      setFieldValue(name, initialValue);
    }
  }, [initialValue, setFieldValue, name, values]);

  return (
    <div className={`mb-2 ${className} `}>
      <label htmlFor={name} className="block font-medium text-[16px] text-gray-600">{label || ''} &nbsp; {required ? <b className="text-redPrimary">*</b> : ' '}</label>
      <AsyncSelect
        cacheOptions
        defaultOptions={true}
        loadOptions={loadOptions}
        getOptionValue={(item) => valueProperty ? item[valueProperty] : item}
        styles={inputStyles}
        isClearable={true}
        isMulti={isMulti}
        onChange={handleOnChange}
        value={initialOptions}
      />

      {pluck(name, errors) ? <small className="text-redPrimary/90" aria-live="polite">{pluck(name, errors)}</small> : null}
    </div>
  );
};



export default AutocompleteAsyncFormik;